(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oasis-collection-refinements"] && !Shopify.designMode) return;
  try {
    (() => {
    function initCollectionRefinements() {
      if (!document.body.classList.contains('oasis-refined-collection')) return;
      const count = document.querySelector('[data-oasis-lot-count]');
      const grid = document.getElementById('product-grid');
      if (count && !count.dataset.connected) {
        count.dataset.connected = 'true';
        const update = (number) => {
          count.querySelector('[data-oasis-lot-number]').textContent = number;
          count.querySelector('[data-oasis-lot-label]').textContent = number === 1 ? count.dataset.one : count.dataset.many;
        };
        const refresh = () => update(grid ? [...grid.querySelectorAll('[data-lot-filter-item]')].filter(card => !card.hidden && card.style.display !== 'none').length : 0);
        document.addEventListener('lot-filter:change', refresh);
        if (grid) new MutationObserver(refresh).observe(grid, { childList: true });
        refresh();
      }
      const header = document.querySelector('.section-header');
      if (header && !header.dataset.collectionOffset) {
        header.dataset.collectionOffset = 'true';
        let pending = false;
        const updateOffset = () => {
          pending = false;
          const rect = header.getBoundingClientRect();
          const position = getComputedStyle(header).position;
          const bottom = position === 'sticky' || position === 'fixed' ? Math.max(0, rect.bottom) : 0;
          document.body.style.setProperty('--ol-header-bottom', `${Math.round(bottom)}px`);
        };
        const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(updateOffset); } };
        new ResizeObserver(schedule).observe(header);
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', schedule, { passive: true });
        updateOffset();
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCollectionRefinements, { once: true });
    else initCollectionRefinements();
    document.addEventListener('shopify:section:load', initCollectionRefinements);
  })();
  } catch(e) { console.error(e); }
})();

})();
